import getDetailsofNotificationsummary from "./getDetailsofNotificationsummary";
const NotificationsSummary = {
    getDetailsofNotificationsummary,
};

export default NotificationsSummary;